import React from 'react';
import { Button } from '@/components/ui/button';
import { Grid3X3, List, Table } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export type ViewMode = 'cards' | 'list' | 'table';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const ViewModeToggle = ({ viewMode, onViewModeChange }: ViewModeToggleProps) => {
  const { t } = useLanguage();

  return (
    <div className="flex gap-1 bg-muted p-1 rounded-lg">
      <Button
        variant={viewMode === 'cards' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('cards')}
        className="h-8 px-3"
      >
        <Grid3X3 className="h-3 w-3 mr-1" />
        {t('cards', 'بطاقات', 'Cards')}
      </Button>
      <Button
        variant={viewMode === 'list' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('list')}
        className="h-8 px-3"
      >
        <List className="h-3 w-3 mr-1" />
        {t('list', 'قائمة', 'List')}
      </Button>
      <Button
        variant={viewMode === 'table' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('table')}
        className="h-8 px-3"
      >
        <Table className="h-3 w-3 mr-1" />
        {t('table', 'جدول', 'Table')}
      </Button>
    </div>
  );
};

export default ViewModeToggle;